/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { EntitlementType } from './entitlement-type';
import { LocalizedFieldBody } from './localized-field-body';
import { TargetPlatform } from './target-platform';
import { UiModuleExperimentGroup } from './ui-module-experiment-group';

/**
 * 
 * @export
 * @interface BaseModuleBody
 */
export interface BaseModuleBody {
    /**
     * 
     * @type {string}
     * @memberof BaseModuleBody
     */
    moduleId?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseModuleBody
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseModuleBody
     */
    hash?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseModuleBody
     */
    moduleType: BaseModuleBodyModuleTypeEnum;
    /**
     * 
     * @type {Array<TargetPlatform>}
     * @memberof BaseModuleBody
     */
    targetPlatform?: Array<TargetPlatform>;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof BaseModuleBody
     */
    caption?: LocalizedFieldBody;
    /**
     * 
     * @type {Array<EntitlementType>}
     * @memberof BaseModuleBody
     */
    entitlements?: Array<EntitlementType>;
    /**
     * 
     * @type {Array<UiModuleExperimentGroup>}
     * @memberof BaseModuleBody
     */
    experiments?: Array<UiModuleExperimentGroup> | null;
}

/**
    * @export
    * @enum {string}
    */
export enum BaseModuleBodyModuleTypeEnum {
    ACCOUNT_CREATION = 'ACCOUNT_CREATION',
    ACCOUNT_LOADING = 'ACCOUNT_LOADING',
    ACCOUNT_SUCCESS = 'ACCOUNT_SUCCESS',
    AI_SEARCH = 'AI_SEARCH',
    BECAUSE_YOU = 'BECAUSE_YOU',
    COLLECTION_LIST = 'COLLECTION_LIST',
    COLLECTION_SPLASH_HERO = 'COLLECTION_SPLASH_HERO',
    CONTENT_LIST = 'CONTENT_LIST',
    CONTINUE_WATCHING = 'CONTINUE_WATCHING',
    COPY = 'COPY',
    GEO_BLOCK = 'GEO_BLOCK',
    HERO = 'HERO',
    SHORT_NOVELAS_CLIPS = 'SHORT_NOVELAS_CLIPS',
    INLINE_PAGE = 'INLINE_PAGE',
    INLINE_PROMO = 'INLINE_PROMO',
    LINKING_ACCOUNT = 'LINKING_ACCOUNT',
    LIVE_NEWS = 'LIVE_NEWS',
    LIVE_PLUS = 'LIVE_PLUS',
    MENU_ITEM = 'MENU_ITEM',
    MENU_SECTION = 'MENU_SECTION',
    NEW_PARTNER_LANDING = 'NEW_PARTNER_LANDING',
    ONE_BRAND_PROMO = 'ONE_BRAND_PROMO',
    PAGE_LIST = 'PAGE_LIST',
    PLAN_SUMMARY = 'PLAN_SUMMARY',
    PLAYBACK_PAYWALL = 'PLAYBACK_PAYWALL',
    PROFILE = 'PROFILE',
    RECOMMENDATIONS = 'RECOMMENDATIONS',
    REGISTRATION_WALL = 'REGISTRATION_WALL',
    SPORTS_EVENT = 'SPORTS_EVENT',
    SPORTS_HERO = 'SPORTS_HERO',
    TOURNAMENT_LIST = 'TOURNAMENT_LIST',
    TOURNAMENT_SPLASH_HERO = 'TOURNAMENT_SPLASH_HERO',
    WATCH_LIST = 'WATCH_LIST',
    TDS_GIFT_CARDS = 'TDS_GIFT_CARDS',
    SPIN_PREMIA = 'SPIN_PREMIA',
    WHO_IS_WATCHING = 'WHO_IS_WATCHING',
    MIXED_LIST = 'MIXED_LIST',
    PERSONALIZED_CONTENT = 'PERSONALIZED_CONTENT',
    OUTBOUND = 'OUTBOUND',
    SUBSCRIPTION_PLAN_DETAILS = 'SUBSCRIPTION_PLAN_DETAILS',
    NOTIFICATIONS = 'NOTIFICATIONS',
    DYNAMIC_MODULE = 'DYNAMIC_MODULE'
}



